import { Element } from "@xmpp/xml"
import { DeliveryOrderExportStatus } from "@/reducers/deliveryOrderExportStatusesSlice"
import PubSubEventParser from "./PubSubEventParser"

export const SLT_DELIVERY_ORDER_EXPORTS_NODE =
  "urn:slickshift:slt-delivery-order-exports:0"

const DELIVERY_ORDER_EXPORT_PAYLOAD_NS =
  "urn:slickshift:delivery-order-export:0"

export const parseDeliveryOrderExportStatusItem = (
  item: Element,
): DeliveryOrderExportStatus | undefined => {
  const exportStatus = item.getChild(
    "delivery-order-export-status",
    SLT_DELIVERY_ORDER_EXPORTS_NODE,
  )
  if (!exportStatus) return

  // Item id carries the driver's room JID (e.g. bike_mugnosky@conference.mike)
  const roomJid = item.getAttr("id")
  const deliveryOrderId = exportStatus.getAttr("delivery_order_id")
  const status = exportStatus.getAttr("status")
  if (!roomJid || !deliveryOrderId || !status) return

  const deliveryOrder = exportStatus
    .getChild("payload")
    ?.getChild("delivery-order", DELIVERY_ORDER_EXPORT_PAYLOAD_NS)
  const driver = deliveryOrder?.getChild("driver")

  return {
    roomJid,
    deliveryOrderId,
    status,
    errorMessage: exportStatus.getAttr("error_message") || undefined,
    externalId: exportStatus.getAttr("external_id") || undefined,
    syncedAt: exportStatus.getAttr("synced_at") || undefined,
    driverName: driver?.getChildText("name") || undefined,
    carPlates: driver?.getChildText("car-plates") || undefined,
    vatId:
      deliveryOrder?.getChild("client")?.getChildText("vat-id") || undefined,
  }
}

export const DeliveryOrderExportStatusPubSubParser =
  new PubSubEventParser<DeliveryOrderExportStatus>(
    parseDeliveryOrderExportStatusItem,
    SLT_DELIVERY_ORDER_EXPORTS_NODE,
  )
